import { Box } from '@mui/material';
import { useGetAllPatientResourcesByID } from '_api';
import { SelectMultipleField } from 'components/molecules/formFields';
import React from 'react';
import { useResources } from 'utils/hooks';

import { FormBuilder } from './form-builder';
import { AddResourceToPatientProfileFormProps } from './types';

export const AddResourceToPatientProfileForm = ({
  onSubmit,
  onBack,
  updateListOfObjects,
  patientId,
}: AddResourceToPatientProfileFormProps) => {
  const { resourceOptions, isLoading } = useResources();
  const isFetched = !isLoading;
  const { data: patientResources } = useGetAllPatientResourcesByID(patientId);

  const updateResourceList = async (key: any, arg: string[]) => {
    updateListOfObjects(arg);
  };

  const filteredResourceOptions = () => {
    if (patientResources) {
      return resourceOptions.filter(
        (option) =>
          !patientResources.some(
            (patientResource) => patientResource.content.id === Number(option.name),
          ),
      );
    }
    return [];
  };

  const resourceFormFields = [
    {
      component: SelectMultipleField,
      fieldKey: 'contentId',
      label: `Select Resource`,
      options: filteredResourceOptions() || [],
      required: true,
      xs: 12,
    },
  ];

  return isFetched ? (
    <Box style={{ maxHeight: '900px' }}>
      <FormBuilder
        formFields={resourceFormFields}
        onSubmit={onSubmit}
        onBack={onBack}
        onUpdate={updateResourceList}
        backLabel="Cancel"
        submitLabel="Save"
      />
    </Box>
  ) : null;
};
